module.exports = "h3 {\n  text-align: center;\n  margin-top: 30%; }\n\np {\n  text-align: center; }\n"